<mat-chip-list *ngIf="text" cdkDropList cdkDropListOrientation="horizontal">
    <mat-chip [ngClass]="{
        'danger': type ==='primary',
        'outline': type ==='outline'
    }" cdkDrag *ngFor="let e of [].constructor(1)">
        {{text}}
    </mat-chip>
</mat-chip-list>